import {flashMessages, modals} from "../../../ducks";

/**
 * Creates a function that removes a duck entity with a prompt for confirmation.
 *
 * @param {object} options - options for the removal operation
 * @param {function} options.dispatch - redux dispatch function
 * @param {object} options.duck - duck entity
 * @param {function} options.confirmMessage - function that returns the confirmation message
 * @param {function} options.successMessage - function that returns the success message
 * @returns {function} - function that removes an entity
 */
const createDeleteEntityHandler = ({dispatch, duck, confirmMessage, successMessage}) => (entity) => {
  dispatch(modals.actions.show("VerificationModal", {
    closeText: "Cancel",
    title: "Confirm Delete",
    message: confirmMessage(entity),
    onConfirm: () => {
      dispatch(duck.actions.remove({id: entity.id}))
        .then(() => dispatch(duck.actions.markDirty()))
        .then(() => dispatch(flashMessages.actions.show({
          message: successMessage(entity),
          type: "success",
          dismissible: true
        })))
        .catch((response) => {
          dispatch(flashMessages.actions.show({
            message: response.error || "An unexpected error occurred",
            type: "danger",
            dismissable: true
          }));
        });
    }
  }))
};

export {createDeleteEntityHandler};
